import { render, staticRenderFns } from "./MarketCharityLanding.vue?vue&type=template&id=eb95f3f2&"
import script from "./MarketCharityLanding.vue?vue&type=script&lang=js&"
export * from "./MarketCharityLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports